import Device from "../common/device";

class Ancre {
    static init() {
        this.blocs = document.querySelectorAll(".flexancre");
        this.blocsWithAncre = [...document.querySelectorAll("[data-ancre]")];
        this.device = Device.getCurrent();

        if (this.blocsWithAncre.length > 0) {
            this.blocs.forEach(bloc => {
                let ul = document.createElement("ul");
                bloc.appendChild(ul);

                this.blocsWithAncre.forEach(blocWithAncre => {
                    let id = (blocWithAncre.id === "" ? this.genereID() : blocWithAncre.id);
                    blocWithAncre.id = id;
                    let titre = blocWithAncre.dataset.ancre.replace(/\\/g, '');
                    let li = document.createElement("li");
                    let a = document.createElement("a");
                    a.href = "#" + id;
                    a.innerHTML = titre;
                    li.appendChild(a);
                    ul.appendChild(li);
                });
                
                if (this.device === 'desktop') {
                    window.addEventListener('scroll', () => this.stickHandler(bloc))
                }
            });
        }
    }

    static genereID() {
        let id = "bloc" + Math.floor(100000 * Math.random());
        while (document.querySelector("#" + id)) {
            id = "bloc" + Math.floor(100000 * Math.random());
        }
        return id;
    }

    static stickHandler(bloc) {
        // variables
        let header = document.querySelector('.header');
        let headerSticky = document.querySelector('.header__sticky');
        let headerHeight = headerSticky.clientHeight;
        let headerAncre = header.querySelector('.flexancre');

        // création du trait
        let barre = document.createElement('div');
        barre.className = 'header__menu__trait';

        // Gestion du sticky
        if (bloc.getBoundingClientRect().bottom - headerHeight <= 0) {
            // On clone l'élément
            let clone = bloc.cloneNode(true);

            // On l'ajoute dans le header
            if (!header.contains(headerAncre)) {
                header.append(clone);

                // On lui ajoute le trait
                clone.append(barre);
            }
        } else {
            // On l'enlève du header
            if (header.contains(headerAncre)) {
                headerAncre.remove()
            }
        }

        // Gestion des classes dans le menu
        this.barHandler();
    }

    static barHandler() {
        let pageItems = document.querySelectorAll('[data-ancre]');
        let newBar = document.querySelector('.header .flexancre .header__menu__trait');
        let anchorItems = document.querySelectorAll('.header .flexancre li');
        let lastItem;
        let currentItem;

        pageItems.forEach(el => {
            let id = el.id;
            let box = document.querySelector(`#${id}`).getBoundingClientRect();
   
            if (box.top <= (window.innerHeight / 2) && box.bottom >= 0) {
                anchorItems.forEach(anchorItem => {
                    if (anchorItem.querySelector('a').getAttribute('href') === `#${id}`) {
                        currentItem = anchorItem;
                        this.barRender(currentItem, lastItem, newBar);
                    }
                })
            }
        });

        if (newBar) {
            newBar.addEventListener("transitionend", () => {
                newBar.classList.remove("header__menu__trait--withTransition");
            })
        }
    }

    static barRender(currentItem, lastItem, barre) {
        if (currentItem) {
            if (lastItem !== currentItem) {
                lastItem = currentItem;
                barre.classList.add("header__menu__trait--withTransition");
            }

            let info = currentItem.getBoundingClientRect();
            let left = currentItem.offsetLeft;
            let width = info.width;

            barre.style.width = width + "px";
            barre.style.left = left + "px";
        }
    }
}

export default Ancre;


// WEBPACK FOOTER //
// ./src/scripts/components/ancre.js